/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoxPalletInfoVo
 */
export interface BoxPalletInfoVo {
    /**
     * 唛头号
     * @type {string}
     * @memberof BoxPalletInfoVo
     */
    markNo?: string;
    /**
     * CBM
     * @type {number}
     * @memberof BoxPalletInfoVo
     */
    cbm?: number;
    /**
     * 重量（kg）
     * @type {number}
     * @memberof BoxPalletInfoVo
     */
    wtKg?: number;
    /**
     * 宽度（cm）
     * @type {number}
     * @memberof BoxPalletInfoVo
     */
    width?: number;
    /**
     * 高度（cm）
     * @type {number}
     * @memberof BoxPalletInfoVo
     */
    height?: number;
    /**
     * 长度（cm）
     * @type {number}
     * @memberof BoxPalletInfoVo
     */
    length?: number;
}

/**
 * Check if a given object implements the BoxPalletInfoVo interface.
 */
export function instanceOfBoxPalletInfoVo(value: object): value is BoxPalletInfoVo {
    return true;
}

export function BoxPalletInfoVoFromJSON(json: any): BoxPalletInfoVo {
    return BoxPalletInfoVoFromJSONTyped(json, false);
}

export function BoxPalletInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxPalletInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'length': json['length'] == null ? undefined : json['length'],
    };
}

export function BoxPalletInfoVoToJSON(json: any): BoxPalletInfoVo {
    return BoxPalletInfoVoToJSONTyped(json, false);
}

export function BoxPalletInfoVoToJSONTyped(value?: BoxPalletInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'markNo': value['markNo'],
        'cbm': value['cbm'],
        'wtKg': value['wtKg'],
        'width': value['width'],
        'height': value['height'],
        'length': value['length'],
    };
}

